import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '@/store';
import { IPushOrderState, SLICE_NAME } from './models';

const pushOrderSelector = (state: RootState): IPushOrderState => state[SLICE_NAME];

export const selectPushOrderLoading = createSelector(pushOrderSelector, (state: IPushOrderState) => state.isLoading);

export const selectPushOrderError = createSelector(pushOrderSelector, (state: IPushOrderState) => state.error);
